import React from 'react'
// CSS
import "../../css/product/list-products.css"

// React
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

// Services FIREBASE
import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore'
import { db, storage } from '../../firebase'
import { getStorage, ref, deleteObject } from "firebase/storage";

import deleteIcon from "../../images/icons8-eliminar-64.png";



function ListTracksToUpdate() {
  const navigate = useNavigate();

  // States
  const [isFetching, setIsFetching] = useState(true);
  const [listTracks, setListTracks] = useState()



  useEffect(() => {
    getData()
  }, [])
  const getData = async () => {
    const docs = []
    const querySnapshot = await getDocs(collection(db, "tracks"));
    console.log("querySnapshot", querySnapshot)
    querySnapshot.forEach((doc) => {
      docs.push({ ...doc.data() })
      setListTracks(docs)
    })
    setIsFetching(false)

  }

const handleDeleteTrack = async (each) => {
  console.log("eachTrack en handleDelete", each);
  const confirmDelete = window.confirm(`¿Estás seguro que quieres borrar el track "${each.title}"?`);

  if (!confirmDelete) return;

  try {
    const storage = getStorage();

    // 👉 función para descomponer la URL del archivo de Storage
    function getStoragePathFromUrl(url) {
      console.log("url en la función de sacar el path", url);
      const start = url.indexOf("/o/") + 3;
      const end = url.indexOf("?");
      const pathEncoded = url.substring(start, end);
      return decodeURIComponent(pathEncoded); // convierte audios%2Ftrack.mp3 → audios/track.mp3
    }

    // 1️⃣ BORRAR EL AUDIO DEL STORAGE
    if (each.audio) {
      const audioRef = ref(storage, getStoragePathFromUrl(each.audio));
      await deleteObject(audioRef);
      console.log(`Audio de "${each.title}" borrado correctamente del Storage`);
    }

    // 2️⃣ BORRAR LA IMAGEN DEL STORAGE (si existe)
    if (each.picture) {
      const pictureRef = ref(storage, getStoragePathFromUrl(each.picture));
      await deleteObject(pictureRef);
      console.log(`Imagen de "${each.title}" borrada correctamente del Storage`);
    }

    alert(`Archivos del track "${each.title}" borrados correctamente del Storage`);
    setTimeout(() => {
      navigate("/admin");
    }, 2000);

  } catch (error) {
    alert(`Ha sucedido un error al eliminar archivos del track "${each.title}"`);
    console.error("Error al eliminar archivos de Storage:", error);
    return;
  }

  // 3️⃣ BORRAR EL DOCUMENTO EN FIRESTORE
  try {
    await deleteDoc(doc(db, "tracks", each.id));
    alert(`Track "${each.title}" borrado correctamente de Firestore`);
    navigate("/admin");
  } catch (error) {
    console.error("Error al eliminar el documento de Firestore:", error);
    navigate("/error");
  }
};



  if (isFetching === true) {
    return <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
  }


  return (
    <div>
      <h1>Tracks</h1>
      <div className='products-container'>
        <table className='product-table'>
          <thead>
            <tr>
              <th>Picture</th>
              <th>Title</th>
              <th>Dj</th>
              <th>AudioLink</th>
              <th>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            {listTracks.map((eachTrack) => (
              <tr key={eachTrack.id}>
                <td>
                  <img src={eachTrack.picture} alt="pict" />
                </td>
                <td>
                  {eachTrack.title}
                </td>
                <td>{eachTrack.dj}</td>

                <td>{eachTrack.audio}</td>

                <td>
                  <img
                    onClick={() => handleDeleteTrack(eachTrack)}
                    className="delete-icon"
                    src={deleteIcon}
                    alt="delete-icon"
                    style={{
                      width: "24px",
                      height: "24px",
                      cursor: "pointer",
                      display: "block",
                      margin: "0 auto"
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

  )
}

export default ListTracksToUpdate